// export const TT_URL = "http://192.168.33.23:3001"
export const TT_URL = "https://traf.to"